import { Button } from "@mui/material";
import i18n from "../../services/localization-service/i18n";

export type StepMenuLandingCardDetailsButtonProps = {
    expanded: boolean;
    onClick: () => void;
};

export default function StepMenuLandingCardDetailsButton({
    expanded,
    onClick
}: StepMenuLandingCardDetailsButtonProps) {
    return (
        <Button
            variant="text"
            onClick={onClick}
        >
            {expanded ? i18n.t("stepMenu.collapse") : i18n.t("stepMenu.expand")}
        </Button>
    );
}
